import { useServiceProps, errorService, } from "ftl-core";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FTLErrorPage from "../components/errors/FTLErrorPage";
export default ({ service = errorService, children, basePath, fullScreen, }) => {
    const [props] = useServiceProps(service);
    const location = useLocation();
    useEffect(() => {
        service.hide();
    }, [location.pathname]);
    return (React.createElement(FTLErrorPage, Object.assign({ fullScreen: fullScreen, basePath: basePath, hasError: false }, props), children));
};
//# sourceMappingURL=ErrorContainer.js.map